<template>
  <v-app>
    <v-main>
      <div class="success-page">
        <v-card
          elevation="5"
          class="d-flex flex-column align-center justify-center py-5 px-10"
        >
          <!-- Lottie Animation using DotLottieVue -->
          <DotLottieVue
            class="lottie-animation mb-4"
            style="height: 300px; width: 300px"
            autoplay
            loop
            src="https://lottie.host/647496a1-0d58-4121-ada5-f4dfe78f1167/zTxgkGKykB.lottie"
          />

          <h2 class="title">Votre inscription a été soumise avec succès!</h2>
          <p class="description">Nous vous contacterons bientôt.</p>
          <v-btn
            class="return-button"
            color="primary"
            @click="goToHome"
            :style="buttonStyle"
            @mouseover="hoverButton"
            @mouseleave="resetButton"
          >
            Retour à l'accueil
          </v-btn>
        </v-card>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
import { ref, onMounted, computed, onBeforeUnmount } from "vue";

export default {
  name: "SuccessView",
  components: {
    DotLottieVue,
  },
  methods: {
    goToHome() {
      // Navigate to the home page
      this.$router.push("/");
    },
    hoverButton() {
      this.isHovered = true;
    },
    resetButton() {
      this.isHovered = false;
    },
  },
  setup() {
    const windowWidth = ref(window.innerWidth);
    const isHovered = ref(false);

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", handleResize);
    });

    const navigationOptions = computed(() => {
      return windowWidth.value <= 1323;
    });

    const buttonStyle = computed(() => {
      return {
        transform: isHovered.value ? "scale(1.05)" : "scale(1)",
        boxShadow: isHovered.value
          ? "0 8px 16px rgba(0, 0, 0, 0.2)"
          : "0 4px 8px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      };
    });

    return {
      navigationOptions,
      isHovered,
      buttonStyle,
    };
  },
};
</script>

<style scoped>
.success-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-image: url("@/assets/bg.png");
  background-size: cover;
  background-position: center;
}

.v-card {
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent white */
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 500px;
  text-align: center;
  padding: 40px;
}

.title {
  font-size: 2rem;
  color: #419e44; /* Green color for success */
  margin: 16px 0;
}

.description {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 24px;
}

.return-button {
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 11px 24px;
  border-radius: 8px;
  text-transform: uppercase;
  background: linear-gradient(
    45deg,
    #419e44,
    #4caf50
  ); /* Gradient background */
  color: white;
  border: none;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
}

.return-button:hover {
  background: linear-gradient(
    45deg,
    #4caf50,
    #419e44
  ); /* Reverse gradient on hover */
}
@media (max-width: 640px) {
  .v-card {
    width: 80%;
    margin-top: 30px;
  }
  .title {
    font-size: 1.3rem;
    margin: 5px 0;
  }
  .description {
    font-size: 0.9rem;
    margin-bottom: 10px;
  }
}
</style>
